<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <v-row>
                    <v-col>
                        <v-row no-gutters>
                            <v-col class="v-label theme--light mb-2">
                                <label :class="{'primary--text' : open}">{{label}}</label>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col v-if="open">
                                {{$translate(hint || 'Set basic colors')}}
                            </v-col>
                            <v-col v-else>
                                <v-avatar
                                    class="mr-2"
                                    size="30"
                                    :color="color[colorKey]"
                                    v-for="colorKey in ['primary', 'secondary', 'accent', 'warning', 'info', 'error', 'success', 'primarytext', 'zoezi-edit-color']"
                                    :key="colorKey"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-avatar
                    class="z-clickable mr-2"
                    size="30"
                    :color="color[colorKey]"
                    v-for="colorKey in ['primary', 'secondary', 'accent', 'warning', 'info', 'error', 'success', 'primarytext', 'zoezi-edit-color']"
                    :key="colorKey"
                    @click="selectedColor = colorKey"
                    :style="{border: selectedColor == colorKey ? '2px solid black !important' : '2px solid #DDD !important'}"
                />
                <div class="title" v-text="selectedColorTitle" />
                <v-color-picker :value="color[selectedColor]" v-on:update:color="setValue($event)" />
                <v-btn color="primary" class="zoezi-button-thin" outlined @click.prevent="clear()">{{$translate('Reset colors')}}</v-btn>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
  export default {
    name: 'ColorThemeSettings',

    props: ['value', 'label', 'hint'],
    data: () => ({
        selectedColor: 'primary',
        color: {}
    }),
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.color = Object.assign({}, value);
            }
        }
    },
    computed: {
        selectedColorTitle() {
            const colorMap = {
                'primary': 'Primary color',
                'secondary': 'Secondary color',
                'accent': 'Accent color',
                'warning': 'Warning color',
                'info': 'Information color',
                'success': 'Success color',
                'error': 'Wrong color',
                'primarytext': 'Color of text written on primary color',
                'zoezi-edit-color': 'Color homepage editor'
            }

            return this.$translate(colorMap[this.selectedColor]);
        }
    },
    methods: {
        setValue(value) {
            this.color[this.selectedColor] = value.hex;
            this.$emit('input', this.color);
        },
        clear() {
            this.color = Object.assign({}, this.$vuetify.theme.defaults.light);
            this.color['primarytext'] = '#ffffff';
            this.$emit('input', this.color);
        }
    }
  }
</script>